import DashboardLink from './DashboardLink';

export default DashboardLink;